import { render } from "./BacklogTarefas.vue?vue&type=template&id=458f5401&scoped=true"
import script from "./BacklogTarefas.vue?vue&type=script&lang=js"
export * from "./BacklogTarefas.vue?vue&type=script&lang=js"

import "./BacklogTarefas.vue?vue&type=style&index=0&id=458f5401&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458f5401"]])

export default __exports__